import { emailBuilderEn } from '../../../translations/email-builder-en'

interface DefaultTemplateCopy {
  heading: string
  paragraph: string
  subject: string
}

// `defaults` is typed as `unknown` on BuilderTranslationMap (see OWN-5980). The
// concrete shape is owned by email-builder-en.ts, which is the single source of
// truth for the starter-template copy seeded by blank/offer/menuItem templates.
const templateDefaults = (emailBuilderEn.defaults ?? {}) as Record<
  string,
  DefaultTemplateCopy
>

// Every heading/paragraph string seeded into a starter template. A text section
// whose content still exactly matches one of these was never edited by the user.
const DEFAULT_TEMPLATE_TEXT: ReadonlySet<string> = new Set(
  Object.values(templateDefaults).flatMap(({ heading, paragraph }) => [
    heading,
    paragraph,
  ])
)

export const isUneditedTemplateText = (
  text: string | null | undefined
): boolean => typeof text === 'string' && DEFAULT_TEMPLATE_TEXT.has(text.trim())
